import { actionButtonMap } from '../../constants/actionButtonMap';
import { ActionItem } from '../../types/button/ActionButton';
import SvgIcon from '../SvgIcon/SvgIcon';

interface ActionPanelButtonsProps {
  actions: ActionItem[];
  row: any;
}

const MAX_ACTIONS_PER_ROW = 7;

const ActionPanelButtons: React.FC<ActionPanelButtonsProps> = ({
  actions,
  row,
}) => {
  /**
   * Divide las acciones en grupos de máximo 7.
   *
   * Ejemplo:
   * 12 acciones =>
   * [
   *   [1, 2, 3, 4, 5, 6, 7],
   *   [8, 9, 10, 11, 12]
   * ]
   */
  const actionRows: ActionItem[][] = [];

  for (let i = 0; i < actions.length; i += MAX_ACTIONS_PER_ROW) {
    actionRows.push(actions.slice(i, i + MAX_ACTIONS_PER_ROW));
  }

  return (
    <div className="flex flex-col gap-2 py-2">
      {actionRows.map((actionRow, rowIndex) => (
        <div
          key={`action-row-${rowIndex}`}
          className="
            flex
            flex-wrap
            items-center
            gap-2
          "
        >
          {actionRow.map((action, index) => {
            const config = actionButtonMap[action.key];

            if (!config) return null;

            const label = action.label ?? config.label;

            return (
              <button
                key={`${action.key}-${index}`}
                type="button"
                onClick={() => action.onClick(row)}
                className={`
                  inline-flex
                  items-center
                  gap-2
                  whitespace-nowrap
                  rounded-lg
                  px-4
                  py-2.5
                  text-sm
                  font-medium
                  text-white
                  shadow-sm
                  transition
                  duration-200
                  hover:scale-[1.02]
                  hover:shadow-md
                  active:scale-[0.98]
                  disabled:cursor-not-allowed
                  disabled:opacity-60
                  ${config.className}
                `}
              >
                <span className="leading-none">
                  {label}
                </span>

                <SvgIcon
                  name={config.iconName as any}
                  className="h-4 w-4 shrink-0"
                />
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default ActionPanelButtons;